import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  message: string = "Test message!";
  messageType: string = "success"; //success, warning, error, info
  messageVisible: boolean = false;

  loadingVisible:boolean = false;



  constructor() { }

  showMessage(m:string, mt:string) {
    this.message = m;
    this.messageType = mt;
    this.messageVisible = true;

    setTimeout(() => {
      this.closeMessage();
    }, 3000);
  }

  closeMessage() {
    this.message = "";
    this.messageType = "";
    this.messageVisible = false;
  }

  showLoading(){
    this.loadingVisible = true;
  }

  hideLoading(){
    this.loadingVisible = false;
  }

}
